import img67 from './EquipoMedico/img67.jpg'
import img68 from './EquipoMedico/img68.jpg'
import { Footer } from './Footer'
import React, { Component } from 'react'
import { Card, Row, Col, Container } from 'react-bootstrap'
import { Navigation } from './Navigation'

export class Operaciones extends Component {
    render() {
        const salas = [
            { img: img67, title: "Sala de operaciones I" },
            { img: img68, title: "Sala de operaciones II" }
        ];

        return (
            <div>
                <Navigation />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Sala de Operaciones</h1>
                        </Col>
                    </Row>
                    <br />

                    {/* Usamos 2 columnas para que el equipo de cirugía se vea imponente */}
                    <Row xs={1} lg={2} className="g-5 text-center justify-content-center">
                        {salas.map((sala, idx) => (
                            <Col key={idx}>
                                <Card className="h-100 shadow border-0">
                                    <Card.Body className="p-2">
                                        <Card.Img 
                                            variant="top" 
                                            src={sala.img} 
                                            style={{ 
                                                height: '500px', 
                                                objectFit: 'contain',
                                                padding: '10px'
                                            }} 
                                        />
                                    </Card.Body>
                                    <Card.Footer className="bg-white border-0">
                                        <Card.Title style={{ fontSize: '1.6rem', padding: '10px' }}>
                                            {sala.title}
                                        </Card.Title>
                                    </Card.Footer>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}